import { render, staticRenderFns } from "./PromotionFormV2.vue?vue&type=template&id=60987b1b&scoped=true&"
import script from "./PromotionFormV2.vue?vue&type=script&lang=js&"
export * from "./PromotionFormV2.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFormV2.vue?vue&type=style&index=0&id=60987b1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60987b1b",
  null
  
)

export default component.exports